import React, { useRef, useState } from 'react';
import './MusicPlayer.css';

const songs = [
    { file: '/animals.mp3', name: 'ANIMALS' },
    { file: '/attention.mp3', name: 'ATTENTION' },
    { file: '/unstoppable.mp3', name: 'UNSTOPPABLE' },
    { file: '/Mona-lisa.mp3', name: 'MONA LISA' },
    { file: '/die-for-you.mp3', name: 'DIE FOR YOU' }
];

const MusicPlayer = () => {

    const audioRef = useRef(null);

    const [isPlaying, setIsPlaying] = useState(false);
    const [isMuted, setIsMuted] = useState(false);

    const [currentSong] = useState(() => {
        return Math.floor(Math.random() * songs.length);
    });

    const toggleMusic = async () => {

        const audio = audioRef.current;

        if (!audio) return;

        if (audio.paused) {

            try {
                await audio.play();
                setIsPlaying(true);
            } catch (error) {
                console.log('Browser blocked audio playback.');
            }

        } else {

            audio.pause();
            setIsPlaying(false);
        }
    };

    const toggleMute = () => {

        const audio = audioRef.current;

        if (!audio) return;

        audio.muted = !audio.muted;

        setIsMuted(audio.muted);
    };

    return (
        <>
            <audio
                ref={audioRef}
                src={songs[currentSong].file}
                preload="auto"
                loop={false}
                onEnded={() => setIsPlaying(false)}
            />

            <div className="music-player">

                <button
                    className="music-player-button"
                    onClick={toggleMusic}
                >
                    {isPlaying ? '⏸' : '▶'}
                </button>

                <span className="music-player-song-name">
                    {songs[currentSong].name}
                </span>

                <button
                    className="music-player-button"
                    onClick={toggleMute}
                >
                    {isMuted ? '🔇' : '🔊'}
                </button>

            </div>
        </>
    );
};

export default MusicPlayer;